import { useEffect } from 'react';

interface UseEmailLinkHandlerProps {
  targetRef: React.RefObject<HTMLElement>;
  isIframe?: boolean;
  enabled?: boolean;
}

export function useEmailLinkHandler({
  targetRef,
  enabled = true,
  isIframe = false,
}: UseEmailLinkHandlerProps) {
  useEffect(() => {
    if (!enabled || !targetRef?.current) return;

    const targetElement = targetRef.current;

    const handleLinkClick = (event) => {
      const target = event.target.closest('a');
      if (target && target.href) {
        event.preventDefault();
        window.open(target.href, '_blank', 'noopener,noreferrer');
      }
    };

    if (isIframe) {
      const iframeElement = targetElement as HTMLIFrameElement;
      let iframeDocument: Document | null = null;

      const handleIframeLoad = () => {
        iframeDocument =
          iframeElement.contentDocument ||
          iframeElement.contentWindow?.document ||
          null;

        if (iframeDocument) {
          iframeDocument.addEventListener('click', handleLinkClick, true);
        }
      };

      targetElement.addEventListener('load', handleIframeLoad);

      return () => {
        targetElement.removeEventListener('load', handleIframeLoad);
        if (iframeDocument) {
          iframeDocument.removeEventListener('click', handleLinkClick, true);
        }
      };
    } else {
      targetElement.addEventListener('click', handleLinkClick, true);

      return () => {
        targetElement.removeEventListener('click', handleLinkClick, true);
      };
    }
  }, [targetRef, isIframe, enabled]);
}
